<template>
  <header :class="['header', { scrolled: isScrolled }]">

    <!-- Top Bar -->
    <div class="top_bar">
      <div class="container">
        <div class="row">
          <div class="col">
            <div
              class="top_bar_content d-flex flex-row align-items-center justify-content-start"
            >
              <div class="top_bar_item">
                <router-link to="/contact">Find a caregiver</router-link>
              </div>
              <div class="top_bar_item">
               <router-link to="/contact">Become a provider</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Header Content -->
    <div class="header_container">
      <div class="container">
        <div class="row">
          <div class="col">
            <div
              class="header_content d-flex flex-row align-items-center justify-content-start"
            >
              <nav class="main_nav ml-auto">
                <ul>
                  <li><router-link to="/">Home</router-link></li>
                  <li><router-link to="/about">About us</router-link></li>
                  <li><router-link to="/services">Our Services</router-link></li>
                  <li><router-link to="/contact">Contact</router-link></li>
                </ul>
              </nav>

              <div class="hamburger ml-auto" @click="toggleMenu"> 
                <font-awesome-icon icon="bars" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Logo -->
    <div class="logo_container_outer">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="logo_container">
              <router-link to="/">
                <div
                  class="logo_content d-flex flex-column align-items-start justify-content-center"
                >
                  <div class="logo_line"></div>

                  <img
                    src="../assets/img/logo.jpg"
                    width="110"
                    height="110"
                    alt="Logo"
                  />
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div :class="['menu_container', { active: menuActive }]">
      <div class="menu_close_container" @click="closeMenu">
        <div class="menu_close"></div>
      </div>

      <div class="menu">
        <div class="menu_inner">
          <ul class="menu_list">
            <li class="menu_item">
              <router-link to="/" @click="closeMenu">Home</router-link>
            </li>
            <li class="menu_item">
              <router-link to="/about" @click="closeMenu">About us</router-link>
            </li>
            <li class="menu_item">
              <router-link to="/services" @click="closeMenu">Our Services</router-link>
            </li>
            <li class="menu_item">
              <router-link to="/contact" @click="closeMenu">Contact</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isScrolled = ref(false);
const menuActive = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 100;
};

const toggleMenu = () => {
  menuActive.value = !menuActive.value;
};

const closeMenu = () => {
  menuActive.value = false;
};

onMounted(() => {
  handleScroll();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.header {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  z-index: 100;
  transition: all 200ms ease;
}

.header.scrolled {
  top: -48px;
}

/*********************************
Top Bar
*********************************/

.top_bar {
  width: 100%;
  background: #283290;
}

.top_bar_content {
  width: 100%;
  height: 48px;
  padding-left: 214px;
}

.top_bar_item {
  margin-left: 33px;
}

.top_bar_item a {
  font-size: 14px;
  color: #ffffff;
  transition: all 200ms ease;
}

.top_bar_item:first-child {
  margin-left: 37px;
}

/*********************************
Header Content
*********************************/

.header_container {
  width: 100%;
  background: #ffffff;
}

.header_content {
  width: 100%;
  height: var(--header-height);
  transition: all 200ms ease;
}

.header.scrolled .header_content {
  height: 80px;
}

.main_nav ul li {
  display: inline-block;
}

.main_nav ul li:not(:first-child) {
  margin-left: 32px;
}

.main_nav ul li a {
  font-size: 16px;
  font-weight: 500;
  color: #323232;
}

.hamburger {
  display: none;
  cursor: pointer;
}

.hamburger i {
  font-size: 24px;
  color: #272727;
}

/*********************************
Logo
*********************************/

.logo_container_outer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.logo_container {
  position: absolute;
  top: 0;
  left: 15px;
  height: var(--logo-height);
  background: #ffffff;
  box-shadow: 0px 31px 29px rgba(0, 0, 0, 0.09);
  z-index: 10;
  transition: all 200ms ease;
}

.header.scrolled .logo_container {
  top: 48px;
  height: 120px;
}

.logo_content {
  width: 100%;
  height: 100%;
}

.logo_line {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  background: #20d34a;
}

/*********************************
Mobile Menu
*********************************/

.menu_container {
  position: fixed;
  top: 0;
  right: -50vw;
  width: 50vw;
  height: 100vh;
  background: #ffffff;
  z-index: 101;
  transition: all 0.6s ease;
  visibility: hidden;
  opacity: 0;
}

.menu_container.active {
  visibility: visible;
  opacity: 1;
  right: 0;
}

.menu {
  position: absolute;
  top: 150px;
  left: 0;
  padding-left: 15%;
}

.menu_list {
  transform: translateY(1.5rem);
  transition: all 1000ms 400ms ease;
  opacity: 0;
}

.menu_container.active .menu_list {
  transform: translateY(0);
  opacity: 1;
}

.menu_item {
  margin-bottom: 5px;
}

.menu_item a {
  font-size: 36px;
  font-weight: 700;
  color: #272727;
}

.menu_close_container {
  position: absolute;
  top: 86px;
  right: 79px;
  width: 21px;
  height: 21px;
  cursor: pointer;
  transform: rotate(45deg);
}

.menu_close {
  position: relative;
  top: 9px;
  width: 21px;
  height: 3px;
  background: #3a3a3a;
}

.menu_close::after {
  content: "";
  position: absolute;
  top: -9px;
  left: 9px;
  width: 3px;
  height: 21px;
  background: #3a3a3a;
}

/*********************************
Responsive
*********************************/

@media (max-width: 991px) {
  .main_nav {
    display: none;
  }

  .hamburger {
    display: block;
  }

  .menu_container {
    width: 80vw;
    right: -80vw;
  }
}
</style>